import React, { useMemo } from 'react';
import styled from 'styled-components';
import HomeV2Footer from './Footer';
import { Col, Layout, Row } from 'antd';
import StaffAvailable from '../StaffAvailable';
import GroupLayoutButton from '../GroupLayoutButton';
import WalkInWaitingList from 'features/user/widgets/WaitingList/WalkIn';
import TicketWaitingList from 'features/user/widgets/WaitingList/Ticket';
import HomeV2Header from './Header';
import userSelectors from 'features/user/services/selectors';
import { EnumColorsButton } from '../ColorsButton/types';
import InfoBox from '../InfoBox';
import shopSelectors from 'services/shop/selectors';
import { HomeLayoutCode } from 'services/shop/constants';
import HomeAptByGroupTime from '../HomeAptByGroupTime';

type IMainProps = {
  model: 'staff' | 'ticket' | 'default';
  setModel: (mode: 'staff' | 'ticket' | 'default') => void;
};
const HomeMainV2: React.FC<IMainProps> = ({ model, setModel }) => {
  const homeBackground = userSelectors.homeBackground();
  const allSetting = shopSelectors.data.allSetting();
  // const globalConfig = shopSelectors.data.allSetting();
  // const listAvailableWorking = userSelectors.listAvailableWorking();
  // const staffs = useMemo(() => listAvailableWorking?.filter(o => o?.staffType === STAFF_TYPE.CASHIER), [listAvailableWorking]) || [];
  // const isManagementTeamViewVisible = globalConfig?.displayCashierClockIn && staffs?.length > 0;
  const configLayout = useMemo(() => {

    if (allSetting?.layoutHomeCode === HomeLayoutCode.LAYOUT_2) {
      return ({
        staffWrapper: '33.3%',
        ticketWrapper: '66.6%',
        apt: 0,
        sw: 12,
        wo: 12,
      });
    }
    if (allSetting?.layoutHomeCode === HomeLayoutCode.LAYOUT_3) {
      return ({
        staffWrapper: '33.3%',
        ticketWrapper: '66.6%',
        apt: 0,
        sw: 8,
        wo: 16,
      });
    }
    if (allSetting?.layoutHomeCode === HomeLayoutCode.LAYOUT_4) {
      return ({
        staffWrapper: '33.3%',
        ticketWrapper: '66.6%',
        apt: 6,
        sw: 6,
        wo: 12,
      });
    }
    return ({
      staffWrapper: '55%',
      ticketWrapper: '45%',
      apt: 0,
      sw: 10,
      wo: 14,
    });

  }, [allSetting?.layoutHomeCode]);
  return (
    <MainStyled>
      <HomeV2Header />
      <Layout.Content style={{ position: 'relative' }}>
        <Layout
          hasSider
          className='container'
          style={{
            overflow: 'hidden',
            background: homeBackground ? `${homeBackground}` : EnumColorsButton.default,
          }}
        >
          <Layout.Sider
            translate='no'
            collapsed={model === 'ticket'}
            reverseArrow
            width={(model === 'default' ? configLayout.staffWrapper : '100%')}
            collapsedWidth={0}
            className='ant-content-overflow sider'
            style={{ borderRight: '1px solid #CCD4DC' }}
          >
            <StaffAvailable v2 mode={model} />
          </Layout.Sider>
          {model === 'default' && <GroupLayoutButton v2 mode={model} setModel={setModel} />}
          <Layout.Sider
            collapsed={model === 'staff'}
            translate='yes'
            reverseArrow={false}
            width={(model === 'default' ? configLayout.ticketWrapper : '100%')}
            collapsedWidth={-1}
            className='sider'
          >
            <div className='wrap-waiting-ticket'>
              <Row className='wrap-tickets-container' style={{ margin: 0 }}>
                {allSetting?.layoutHomeCode === HomeLayoutCode.LAYOUT_4 && <Col span={model === 'ticket' ? 12 : configLayout.apt} className='waiting-ticket'>
                  <HomeAptByGroupTime />
                </Col>}
                <Col span={model === 'ticket' ? 12 : configLayout.sw} className='waiting-ticket'>
                  <WalkInWaitingList v2 mode={model} />
                </Col>
                <Col span={model === 'ticket' ? 12 : configLayout.wo} className='waiting-ticket'>
                  <TicketWaitingList v2 mode={model} />
                </Col>
              </Row>
            </div>
          </Layout.Sider>
        </Layout>
        <InfoBox />
      </Layout.Content>
      {model !== 'default' && <GroupLayoutButton v2 mode={model} setModel={setModel} />}
      <HomeV2Footer />
    </MainStyled>
  );
};

export default HomeMainV2;

const MainStyled = styled(Layout)`
  border-left: 1px solid #ccd4dc;
  .container {
    height: 100%;
  }
  .ant-content-overflow {
    max-height: 100%;
  }
  .children-container {
    padding: 1.125rem;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .sider {
    background: transparent;
    min-height: 40vw;
    transition: all 0.5s, background 0s;
    .ant-layout-sider-children {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }
  .footer {
    position: sticky;
    bottom: 0;
    background:red;
  }
  .wrap-waiting-ticket {
    flex: 1;
    display: flex;
    .wrap-tickets-container {
      flex: 1;
    }
  }
  .waiting-ticket {
    display: flex;
    flex: 1;
    min-height: 50vh;
    gap: 14px;
    position: relative;
    .divider {
      width: 1px;
      background: #ccd4dc;
    }
  }

  .ticket-label-section {
    background: transparent;
  }

  .box-div-scroll {
    background: transparent;
    border-color: #ccd4dc;
  }
`;
